import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Text, Flex, StarRating, Box, Heading } from 'roo-ui/components';
import Image from 'components/Image';
import formatPropertyAddress from 'components/formatters/FormatPropertyAddress';
import GetDirections from 'components/maps/GetDirections';

const Address = ({ address }) => (
  <Text color="greys.charcoal" my={2}>
    {formatPropertyAddress({
      streetAddressLines: address.streetAddress,
      suburb: address.suburb,
      state: address.state,
      country: address.country,
    })}
  </Text>
);

Address.propTypes = {
  address: PropTypes.object.isRequired,
};

const HotelInformation = ({ property }) => {
  const { address, rating, ratingType, mainImage, name } = property;
  const { urlMedium, urlLarge, caption } = mainImage || {};

  const propertyImageSrcSet = mainImage ? `${urlLarge} 2x, ${urlMedium} 1x` : undefined;

  return (
    <Fragment>
      <Heading.h3 fontSize={['base', 'md']} color="greys.charcoal" mb={4} data-print-style="h3">
        Hotel information
      </Heading.h3>
      <Flex position="relative" flexDirection={['column', 'row']}>
        <Box flex={['0 1 auto', '0 1 170px']} mr={[0, 4]} data-print-style="hidden">
          <Image height="130px" lazy src={urlMedium} alt={caption} srcSet={propertyImageSrcSet} mb={2} />
        </Box>
        <Flex flex="1 1 auto" alignSelf="center" flexDirection="column" alignItems="flex-start">
          <Text fontSize="base" fontWeight="bold" color="greys.charcoal" mb={2}>
            {name}
          </Text>
          <StarRating rating={rating} ratingType={ratingType} size={16} />
          <Address address={address} />
          <GetDirections address={address} />
        </Flex>
      </Flex>
    </Fragment>
  );
};

HotelInformation.propTypes = {
  property: PropTypes.object.isRequired,
};

export default HotelInformation;
